// extracted by mini-css-extract-plugin
export default {"navmenu":"NavMenu_navmenu__JnB5l","background":"NavMenu_background__JyYAN","MainNavigation":"NavMenu_MainNavigation__hCWPJ"};